module.exports = __webpack_public_path__ + "static/media/view.88f614c1.png";